import { FC } from "react";
import { AiOutlineExpandAlt } from "react-icons/ai";
import { MdFullscreenExit, MdContentCopy } from "react-icons/md";
import { ModalState, Props } from "./hook";
import {
  FloatingWrapper,
  StylesModalContainer,
  ModalSizeWrapper,
} from "./styled";
import { UnreadThreadsList } from "../UnreadThreadsList";
import CreateChat from "../CreateChat";
import ChatRealTime from "../ChatRealTime";

interface ChatModalInstanceProps {
  modal: ModalState;
  index: number;
  controller: Props;
}

const ChatModalInstance: FC<ChatModalInstanceProps> = ({
  modal,
  index,
  controller,
}) => {
  const isCurrentFullscreen = controller.fullscreenIds.includes(modal.id);

  const renderContent = () => {
    switch (modal.view) {
      case "list":
        return (
          <UnreadThreadsList
            {...controller.listProps}
            onCreateChatClick={() => controller.handleCreateChatClick(modal.id)}
            onThreadClick={(thread) =>
              controller.handleThreadClick(thread, modal.id)
            }
          />
        );
      case "create":
        return (
          <CreateChat
            handleBackToList={() => controller.handleBackToList(modal.id)}
            handleSuccess={(dataMessage: any) => {
              const newThreadId = String(dataMessage?.thread_id || "");
              controller.handleChatCreated(modal.id, newThreadId, dataMessage);
            }}
            onDirtyChange={(isDirty: boolean) => {
              controller.setModals((prev) =>
                prev.map((m) => (m.id === modal.id ? { ...m, isDirty } : m)),
              );
            }}
            isFullscreen={isCurrentFullscreen}
          />
        );
      case "chat":
        return (
          <ChatRealTime
            handleBack={() => controller.handleBackToList(modal.id)}
            isAdmin={controller.listProps.isAdmin}
            threadId={modal.id}
            userId={String(controller.listProps.auth?.id)}
            data={modal.thread}
            onDirtyChange={(isDirty: boolean) => {
              controller.setModals((prev) =>
                prev.map((m) => (m.id === modal.id ? { ...m, isDirty } : m)),
              );
            }}
            isFullscreen={isCurrentFullscreen}
            onRefetchUnreadList={controller.listProps.refetch}
          />
        );
      default:
        return null;
    }
  };

  return (
    <StylesModalContainer
      key={modal.id}
      title={
        <div className="modal-header-with-btn">
          <span>AI問い合わせ</span>
          {modal.view === "chat" && (
            <button
              type="button"
              className="modal-copy-btn"
              onClick={() => controller.handleCopyLink(modal.id)}
              title="Copy chat link"
            >
              <MdContentCopy size={18} />
            </button>
          )}
          <button
            type="button"
            className="modal-fullscreen-btn"
            onClick={(e) => controller.handleToggleFullscreen(modal.id, e)}
            title={
              isCurrentFullscreen ? "Exit fullscreen" : "Expand fullscreen"
            }
          >
            {isCurrentFullscreen ? (
              <MdFullscreenExit size={20} />
            ) : (
              <AiOutlineExpandAlt size={20} />
            )}
          </button>
        </div>
      }
      open={controller.isOpen}
      onCancel={() => controller.handleCloseModal(modal.id)}
      onOk={controller.onOk}
      footer={null}
      transitionName=""
      isFullscreen={isCurrentFullscreen}
      modalRender={(dom) => (
        <FloatingWrapper isFullscreen={isCurrentFullscreen}>
          <ModalSizeWrapper isFullscreen={isCurrentFullscreen}>
            {dom}
          </ModalSizeWrapper>
        </FloatingWrapper>
      )}
      wrapClassName={`modal-bottom-right-wrap modal-index-${index} ${
        isCurrentFullscreen
          ? `modal-fullscreen modal-fullscreen-index-${controller.fullscreenIds.indexOf(
              modal.id,
            )}`
          : ""
      } ${
        controller.fullscreenIds.length > 0 && !isCurrentFullscreen
          ? "has-fullscreen"
          : ""
      }`}
      mask={
        (index === 0 && controller.modals.length === 1) || isCurrentFullscreen
      }
      closable={true}
    >
      {renderContent()}
    </StylesModalContainer>
  );
};

export default ChatModalInstance;
